/* eslint-disable react-hooks/exhaustive-deps */
import { Box } from "@mui/material";
import { useState, useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";

import { getProductDetails } from "../../../actions/defaultPage";
import { getItemDetailsForAllowedCollection } from "../../../actions/hotFoodAction";
import MenuItemContent from "../../../components/MenuItemContent";
import ScrollButton from "../../../components/ScrollButton";
import useGetExtendedEserviceMenu from "../helpers/hooks/useGetExtendedEserviceMenu";
import { setPageItem } from "../helpers/hotFoodCombo.utils";

const HotFoodComboPageItems = (props) => {
    const { sortedItems, activeTabName } = props;
    const [orderCount, setOrderCount] = useState(0);
    const dispatch = useDispatch();
    const [currentPage, setCurrentPage] = useState(0);
    const [lastRowCount, setLastRowCount] = useState(0);
    const { handleGetExtendedEserviceMenu } = useGetExtendedEserviceMenu();

    const {
        tabs,
        subMenuId,
        hideNavigationTab,
        tabsStack,
        hotFoodComboID,
        parentOrderID,
    } = useSelector((state) => state.hotFoodCombo);

    const { newItems, pageLength } = useMemo(
        () =>
            setPageItem({
                items: sortedItems,
                currentPage,
                lastRowCount,
                isHideTabs: hideNavigationTab,
            }),
        [sortedItems, currentPage, lastRowCount, hideNavigationTab],
    );

    useEffect(() => {
        if (pageLength === 1) {
            setCurrentPage(0);
            setLastRowCount(0);
        }
    }, [pageLength]);

    function isEllipsisActive(e) {
        if (!e) return;
        if (e.offsetHeight < e.scrollHeight || e.offsetWidth < e.scrollWidth) {
            return (e.style.fontSize = "11px");
        }
    }

    const handleGetProductDetails = (item) => {
        if (item.requiredAuth && !item.productId) {
            return dispatch({
                type: "SET_PROMPT_OPERATOR_ID",
                promptOperatorId: true,
                pageStackItem: item.name.replace(/\s/g, ""),
            });
        }
        if (item.productId) {
            const { productId, allowCollection } = item;
            const orderID = uuidv4();
            const additionalHotFoodItem = {
                parentOrderID: parentOrderID,
                hotFoodComboID,
                extendedTab: activeTabName,
                orderID,
                isChildCombo: true,
            };
            if (allowCollection) {
                return dispatch(
                    getItemDetailsForAllowedCollection({
                        productId,
                        customSuccessCallback: () => handleGetSides(item),
                        additionalHotFoodItem,
                    }),
                );
            }
            dispatch(getProductDetails(productId, true, null, allowCollection));
        }
    };

    const handleGetSides = (item) => {
        dispatch({
            type: "HFC_SET_ORDERS",
            orders: { category: props.activeTabName, ...item },
        });
        const index = tabs.findIndex((tab) => tab.menuId === subMenuId);
        if (index === tabs.length - 1) {
            const tabStack = tabsStack.find((tab) =>
                tab.find((newtab) => newtab.menuId === subMenuId),
            );
            const menuId = tabStack[0 + 1].menuId;
            return handleGetExtendedEserviceMenu({ menuId });
        }
        const menuId = tabs[0 + 1].menuId;
        handleGetExtendedEserviceMenu({ menuId });
    };

    return (
        <Box
            component={"div"}
            className="hot-food-combo-item-container"
            sx={{
                position: "relative",
                display: "flex",
                alignSelf: "baseline",
                paddingLeft: "8px",
            }}
        >
            <div
                style={{ minWidth: "560px", marginTop: 0, overflow: "hidden" }}
                className={"button-container"}
            >
                {newItems.map((item, index) => {
                    const columnSpan = item.columnSpan || 1;
                    const widthLength = columnSpan * 80 + (columnSpan - 1) * 10;

                    const itemProps = {
                        key: `${item.name}-${index}`,
                        onClick: () => handleGetProductDetails(item),
                        className: `menu-item ${item.productId ? "red" : ""}`,
                        style: {
                            width: `${widthLength}px`,
                            visibility: item.name === "" ? "hidden" : "visible",
                        },
                        ...(item.image && { image: item.image }),
                    };

                    return (
                        <button
                            ref={(el) => isEllipsisActive(el)}
                            {...itemProps}
                        >
                            <MenuItemContent {...item} />
                        </button>
                    );
                })}
            </div>
            {pageLength > 1 && sortedItems.length && (
                <ScrollButton
                    buttonSize={{ width: 72, height: 63 }}
                    lastPage={pageLength - 1}
                    currentPage={currentPage}
                    setCurrentPage={setCurrentPage}
                    setLastRowCount={setLastRowCount}
                    isHideTabs={hideNavigationTab}
                />
            )}
        </Box>
    );
};

export default HotFoodComboPageItems;
